import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/styles/app.scss";
import App from "./App";
import { ChakraProvider } from "@chakra-ui/react";
import { Provider } from "react-redux";
import store from "./redux/store";
import { BrowserRouter } from "react-router-dom";
import axios from "axios";

axios.defaults.headers.post["Content-Type"] = "application/json";

axios.interceptors.request.use(
  (reqConfig) => {
    const reqConfigLocal = { ...reqConfig };
    const token = localStorage.getItem("token");

    if (token) {
      reqConfigLocal.headers.Authorization = `Bearer ${token}`;
    }

    return reqConfigLocal;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // localStorage.clear();
    return Promise.reject(error);
  }
);

const RootApp = () => {
  return (
    <Provider store={store}>
      <ChakraProvider toastOptions={{ defaultOptions: { position: "top-right", isClosable: true } }}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ChakraProvider>
    </Provider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<RootApp />);
